export { classifyError, humanMessage, type ErrorKind } from './classify'
export { buildErrorReport, type ErrorReportInput } from './report'
export { symbolicateStack } from './symbolicate'

/**
 * Единственная точка, куда уходят ошибки приложения.
 * Сейчас — консоль. Sentry подключается здесь, одной строкой.
 */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
  console.error('[prima]', error, context ?? {})
}
